export const LOADING_OBJECTIVE_COMPETENCY = "LOADING_OBJECTIVE_COMPETENCY";
export const SAVE_LOADING_OBJECTIVE_COMPETENCY = "SAVE_LOADING_OBJECTIVE_COMPETENCY";
export const GET_OBJECTIVE_COMPETENCY = "GET_OBJECTIVE_COMPETENCY";
export const FORM_FAIL = "FORM_FAIL";
export const OBJECTIVE_COMPETENCY_FAIL = "OBJECTIVE_COMPETENCY_FAIL";
export const LOADING_OBJECTIVE_COMPETENCY_BY_ID = "LOADING_OBJECTIVE_COMPETENCY_BY_ID";
export const GET_OBJECTIVE_COMPETENCY_BY_ID = "GET_OBJECTIVE_COMPETENCY_BY_ID";

